export default __webpack_public_path__ + "static/autorizacao-de-uso-de-imagem-adulto-0266da448c33938ff274cad306f445ce.pdf";